import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  forwardRef,
  OnDestroy,
  OnChanges,
  ContentChildren,
  QueryList,
} from '@angular/core';

import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { RxRadioDirective } from './rx-radio/rx-radio.directive';
import { CommonModule } from '@angular/common';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';

@Component({
  selector: 'rx-radio-group',
  templateUrl: './rx-radio-group.component.html',
  styleUrls: ['./rx-radio-group.component.scss'],
  imports: [CommonModule, FormsModule, MatRadioModule, MatListModule, ReactiveFormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RxRadioGroupComponent),
      multi: true,
    },
  ],
  standalone: true,
})
export class RxRadioGroupComponent implements OnInit, OnDestroy, ControlValueAccessor, OnChanges {
  // @TODO two different modes for displaying radio button (vertical and horizontal)
  @Input()
  public id = 'item' + Math.random().toString(36).substring(2);

  @Input()
  public makeHorizontal = false;

  @Input()
  public value;

  @Input()
  public ariaLabel: string | null = null;

  @Output()
  public valueChange = new EventEmitter();

  @Input()
  public buttonPosition: 'left' | 'right' = 'left';

  @Input()
  public highlightItem = null;

  public radioButtonsTemplates: RxRadioDirective[] = [];

  public onChange = (value: string) => {};

  public onTouched = () => {};

  @ContentChildren(RxRadioDirective)
  set radioButtons(values: QueryList<RxRadioDirective>) {
    this.radioButtonsTemplates = values.toArray();
  }

  constructor() {}

  public ngOnInit() {}

  public ngOnDestroy() {}

  public ngOnChanges() {}

  public changeRadioButtonValue() {
    this.valueChange.emit(this.value);
    this.onChange(this.value);
  }

  /**
   *   value accessors
   *
   */

  // Register for change
  public registerOnChange(fn: (value: string) => void) {
    this.onChange = fn;
  }

  // Register for touch/click
  public registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  // Update the model and changes
  public writeValue(value: string) {
    if (this.value !== value) {
      this.value = value;
      this.onChange(this.value);
    }
  }
}
